<script>
	import { joinGame } from './services/firebase-service';

	// import screenfull from 'screenfull';

	import Layout from './layout.svelte';

	import GameSettings from './components/game-settings.svelte';

	import { TYPES, TIMER_LENGTHS } from './utils/constants';

	export let authID;
	export let gameID;
	export let game;

	let playerName;
	try {
		playerName = localStorage.getItem('playerName');
	}
	catch(e) {}
	playerName = playerName || '';

	let isJoiningGame = false;

	function onSubmit() {
		isJoiningGame = true;
		joinGame({ authID, gameID, playerName });
		// screenfull.request();
	}
</script>

<Layout className="dynamic">
	<div class="join-game-container" slot="core">
		<form
			class="join-game-form"
			on:submit|preventDefault={onSubmit}>

			<GameSettings {game} />

			<fieldset class="player">
				<legend>What's your name?</legend>
				<input
					class="player-name-input"
					type="text"
					name="player-name"
					bind:value={playerName}
					title="Type your name"
					placeholder="Type your name"
					required="true"
					maxlength="13"
				/>
			</fieldset>

			<fieldset class="buttons">
				<button
					type="submit"
					class="join-game-submit"
					class:colorcycle={isJoiningGame}
					title="Join a new game"
					disabled={!playerName.toString().trim().length || isJoiningGame}
				>
						Join Game
				</button>
			</fieldset>
		</form>
	</div>
</Layout>


<style lang="less">
	@import "./variables.less";

	.join-game-container {
		display: flex;
		width: 100%; height: 100%;
		padding: 5vmin 20vmin;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background: rgba(255, 255, 255, 0.8);
		border: 0.2em solid #313131;
		border-radius: 20%;
		font-size: 1.5em;

		@media (@aspect-ratio) {
			margin: 0 2vmin;
		}

		.join-game-form {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 2em;

			fieldset {
				display: block;
				width: 100%;
				margin: 1.2em 0.5em;
				text-align: center;
			}

			legend {
				width: 100%;
				margin: 0.2em 0;
				font-size: 0.7em;
				font-weight: 700;
				text-align: center;
			}
			input {
				padding: 1em;
				text-align: center;
			}

			button {
				padding: 0.5em;
			}

			.game-name {
				span {
					display: inline-block;
					padding: 0.5em 2em;
					color: white;
					background: #696969;
					border: 0.1em solid white;
					border-radius: 0.5em;
				}
			}
		}
	}

</style>